import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { withRouter } from 'react-router-dom';
import { useFormik } from 'formik';
import { getProviders } from './Providers';
import { updateAccount } from './Account';
import { Link } from 'react-router-dom';
import Input from '../components/form/Input';
import Select from '../components/form/Select';
import Checkbox from '../components/form/Checkbox';
import Loading from '../components/Loading';
import { StatusButton } from './UserAdd';
import { ReactComponent as ChevronLeft } from '../svg/chevron-left.svg';
import Layout from './Layout';

export const getAccount = (username) => {
    return axios.request({
        url: `${process.env.REACT_APP_API_URL}/authorized/users/${username}`,
        method: 'GET'
    });
};

const UserEdit = ({ match = {} }) => {
    const [providers, setProviders] = useState([]);
    const [success, setSuccess] = useState(null);
    const [saving, setSaving] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [email, setEmail] = useState('');
    const { values, setFieldValue, resetForm } = useFormik({
        initialValues: {
            firstname: '',
            lastname: '',
            providerid: '',
            passportadmin: false,
            readonly: false
        }
    });

    useEffect(() => {
        Promise.all([getProviders(), getAccount(match.params.username)]).then(([providers, account]) => {
            setIsLoading(false);
            setProviders(providers.results);
            setFieldValue('firstname', account.data.firstname);
            setFieldValue('lastname', account.data.lastname);
            setEmail(account.data.email);
            setFieldValue('providerid', account.data.providerid);
            setFieldValue('passportadmin', account.data.passportadmin);
            setFieldValue('readonly', account.data.readonly);
        });
    }, [match.params.username, setFieldValue]);

    const handleSubmit = (e) => {
        e && e.preventDefault();
        setSaving(true);

        updateAccount(match.params.username, {
            firstname: values.firstname,
            lastname: values.lastname,
            providerid: values.providerid,
            readonly: values.readonly,
            passportadmin: values.passportadmin
        })
            .then(() => {
                setSuccess(true);
                setSaving(false);
            })
            .catch(() => {
                setSuccess(null);
                setSaving(false);
            });
    };

    return (
        <Layout>
            {isLoading && <Loading />}
            {!isLoading && (
                <>
                    <p>
                        <Link className="alt-link" to="/users">
                            <ChevronLeft width="1em" height="1em" />
                            Back to Users
                        </Link>
                    </p>
                    <div className="page-header">
                        <h1>Edit User: {email}</h1>
                    </div>
                    <div className="row">
                        <form className="col-sm-6" onSubmit={handleSubmit} onReset={resetForm} noValidate>
                            <div className="row">
                                <div className="col-xs-12 col-md-6">
                                    <Input
                                        id="firstname"
                                        label="First Name"
                                        value={values.firstname}
                                        onChange={(id, val) => setFieldValue('firstname', val)}
                                        required
                                    />
                                </div>
                                <div className="col-xs-12 col-md-6">
                                    <Input
                                        id="lastname"
                                        label="Last Name"
                                        value={values.lastname}
                                        onChange={(id, val) => setFieldValue('lastname', val)}
                                        required
                                    />
                                </div>
                            </div>

                            <Select
                                id="providerid"
                                label="Provider"
                                value={values.providerid}
                                onChange={(id, val) => setFieldValue('providerid', val)}
                            >
                                <option value="">Select...</option>
                                {providers.map((provider) => (
                                    <option key={provider.id} value={provider.id}>
                                        {provider.name}
                                    </option>
                                ))}
                            </Select>

                            <Input label="Username" value={match.params.username} showRequired disabled />

                            <div className="mb-4">
                                <Checkbox
                                    label="Passport Admin?"
                                    id="passportadmin"
                                    checked={values.passportadmin}
                                    disabled={!email.includes('inaudio.com')}
                                    onChange={(id, val) => {
                                        setFieldValue('passportadmin', val);
                                    }}
                                />
                                <Checkbox
                                    label="Read Only?"
                                    id="readonly"
                                    checked={values.readonly}
                                    onChange={(id, val) => {
                                        setFieldValue('readonly', val);
                                    }}
                                />
                            </div>

                            <StatusButton
                                label="Save"
                                successLabel="Change Saved"
                                success={success}
                                disabled={saving}
                            />
                        </form>
                    </div>
                </>
            )}
        </Layout>
    );
};

export default withRouter(UserEdit);
